import { useEffect, useRef } from 'react';
import { useAuthContext } from '@/contexts/auth';
import { useStore } from '@/store/useStore';

/**
 * Componente migliorato per la sincronizzazione dello stato di autenticazione
 * tra il contesto React (AuthContext) e lo store Zustand.
 * 
 * Questo componente garantisce che i dati di autenticazione siano sempre sincronizzati
 * e risolve i problemi di sincronizzazione che possono verificarsi.
 */
export function EnhancedAuthSync() {
  const { user, isAuthenticated, isLoading } = useAuthContext();
  const { syncWithAuthContext, user: storeUser, isAuthenticated: storeIsAuthenticated } = useStore();
  
  // Riferimento per tenere traccia dell'ultimo stato sincronizzato
  const lastSyncedState = useRef({
    contextAuth: false,
    storeAuth: false,
    contextUserId: '',
    storeUserId: ''
  });
  
  // Effetto per sincronizzare lo stato di autenticazione
  useEffect(() => {
    const contextUserId = user?.id || '';
    const storeUserId = storeUser?.id || '';
    
    console.log('[EnhancedAuthSync] Stato attuale:', {
      contextAuth: isAuthenticated,
      storeAuth: storeIsAuthenticated,
      contextUserId,
      storeUserId,
      isLoading
    });
    
    // Verifica se è necessaria la sincronizzazione
    const needsSync = 
      isAuthenticated !== storeIsAuthenticated ||
      contextUserId !== storeUserId ||
      // Verifica anche rispetto all'ultimo stato sincronizzato
      isAuthenticated !== lastSyncedState.current.contextAuth ||
      storeIsAuthenticated !== lastSyncedState.current.storeAuth ||
      contextUserId !== lastSyncedState.current.contextUserId ||
      storeUserId !== lastSyncedState.current.storeUserId;
    
    if (needsSync) {
      console.log('[EnhancedAuthSync] Sincronizzazione necessaria, aggiornamento store...');
      
      // Passa lo stato di autenticazione attuale allo store
      syncWithAuthContext(user, isAuthenticated, isLoading);
      
      // Aggiorna il riferimento all'ultimo stato sincronizzato
      lastSyncedState.current = {
        contextAuth: isAuthenticated,
        storeAuth: storeIsAuthenticated,
        contextUserId,
        storeUserId
      };
      
      console.log('[EnhancedAuthSync] Sincronizzazione completata');
    }
  }, [user, isAuthenticated, isLoading, storeUser, storeIsAuthenticated, syncWithAuthContext]);
  
  // Questo componente non renderizza nulla
  return null;
}

export default EnhancedAuthSync;
